import React from 'react';

import styles from './styles.module.scss';

export interface ErrorMessageProps {
  message: string | undefined;
  className?: string;
}

export const ErrorMessage = ({
  message,
  className = '',
}: ErrorMessageProps): React.ReactElement | null => {
  if (!message) {
    return null;
  }

  return (
    <span className={`${styles.errorMessage} ${className}`} role="alert">
      {message}
    </span>
  );
};
